const language = {
    'pt': 
        {
            access_app_link:                'AQUI!',
            access_app_txt:                 'Verifique essa informação acedendo à plataforma',
            assistance:                     'Assistência',
            assistance_close:               'Encerrar assistência',
            assistance_close_confirm:       'Tem a certeza que quer encerrar esta assistência?',
            assistance_closed:              'Pedido de assistência encerrado',
            assistance_closed_email_sent:   'O seu pedido de assistência foi dada como resolvida.',
            assistance_error:               'Erro no envio da assistência',
            assistance_new:                 'Nova assistência',
            assistance_response_email_sent: 'O seu pedido de assistência foi respondido.',
            assistance_success:             'Assistência enviada com sucesso',
            assistances:                    'Assistências',
            at:                             'às',
            back:                           'Voltar',
            cancel:                         'Cancelar',
            complaint:                      'Reclamacão',
            complaint_close:                'Encerrar reclamação',
            complaint_close_confirm:        'Tem a certeza que quer encerrar esta reclamação?',
            complaint_closed:               'Reclamação encerrada',
            complaint_closed_email_sent:    'A sua reclamação foi dada como resolvida.',
            complaint_error:                'Erro no envio da reclamação',
            complaint_new:                  'Nova reclamação',
            complaint_response_email_sent:  'A sua reclamação foi respondida.',
            complaint_success:              'Reclamacão enviada com sucesso',
            complaints:                     'Reclamações',
            confirm:                        'Confirmar',
            choose_client:                  'Escolher cliente',
            choose_service:                  'Escolher serviço/produto',
            label_info:                     'Iníciado',
            label_warning:                  'Em curso',
            label_success:                  'Finalizado',
            message:                        'Descrição',
            new_message:                    'Responder',
            new_send:                       'Enviar resposta',
            proposal:                       'Proposta',
            proposal_close:                 'Encerrar proposta',
            proposal_close_confirm:         'Tem a certeza que quer encerrar esta proposta?',
            proposal_closed:                'Proposta encerrada',
            proposal_closed_email_sent:     'A sua proposta foi dada como resolvida.',
            proposal_error:                 'Erro no envio da proposta',
            proposal_new:                   'Nova proposta',
            proposal_response_email_sent:   'A sua proposta foi respondida.',
            proposal_success:               'Proposta enviada com sucesso',
            proposals:                      'Propostas',
            send:                           'Enviar',
            service:                        'Serviço / Produto',
            show_archive:                   'Mostrar arquivo',
            show_open:                      'Mostrar pendentes',
            subject_assistance_email:       'Assistência',
            subject_complaint_email:        'Reclamação',
            subject_proposal_email:         'Proposta',
            subject_suggestion_email:       'Sugestão',
            suggestion:                     'Sugestão',
            suggestion_close:               'Encerrar sugestão',
            suggestion_close_confirm:       'Tem a certeza que quer encerrar esta sugestão?',
            suggestion_closed:              'Sugestão encerrada',
            suggestion_closed_email_sent:   'A sua sugestão foi dada como resolvida.',
            suggestion_error:               'Erro no envio da sugestão',
            suggestion_new:                 'Nova sugestão',
            suggestion_response_email_sent: 'A sua sugestão foi respondida.',
            suggestion_success:             'Sugestão enviada com sucesso',
            suggestions:                    'Sugestões',
            table_empty:                    'Sem dados para mostrar',
            time_second:                    'segundo',
            time_seconds:                   'segundos',
            time_minute:                    'minuto',
            time_minutes:                   'minutos',
            time_hour:                      'hora',
            time_hours:                     'horas',
            time_day:                       'dia',
            time_days:                      'dias',
            time_week:                      'semana',
            time_weeks:                     'semanas',
            time_mount:                     'mês',
            time_mounts:                    'meses',
            time_year:                      'ano',
            time_years:                     'anos',
            unread:                         'por ler',
        },
    'en': 
        {
            access_app_link:                'AQUI!',
            access_app_txt:                 'Verifique essa informação acedendo à plataforma',
            assistance:                     'Assistência',
            assistance_close:               'Encerrar assistência',
            assistance_close_confirm:       'Tem a certeza que quer encerrar esta assistência?',
            assistance_closed:              'Pedido de assistência encerrado',
            assistance_closed_email_sent:   'O seu pedido de assistência foi dada como resolvida.',
            assistance_error:               'Erro no envio da assistência',
            assistance_new:                 'Nova assistência',
            assistance_response_email_sent: 'O seu pedido de assistência foi respondido.',
            assistance_success:             'Assistência enviada com sucesso',
            assistances:                    'Assistências',
            at:                             'às',
            back:                           'Voltar',
            cancel:                         'Cancelar',
            complaint:                      'Reclamacão',
            complaint_close:                'Encerrar reclamação',
            complaint_close_confirm:        'Tem a certeza que quer encerrar esta reclamação?',
            complaint_closed:               'Reclamação encerrada',
            complaint_closed_email_sent:    'A sua reclamação foi dada como resolvida.',
            complaint_error:                'Erro no envio da reclamação',
            complaint_new:                  'Nova reclamação',
            complaint_response_email_sent:  'A sua reclamação foi respondida.',
            complaint_success:              'Reclamacão enviada com sucesso',
            complaints:                     'Reclamações',
            confirm:                        'Confirmar',
            choose_client:                  'Escolher cliente',
            choose_service:                  'Escolher serviço/produto',
            label_info:                     'Iníciado',
            label_warning:                  'Em curso',
            label_success:                  'Finalizado',
            message:                        'Descrição',
            new_message:                    'Responder',
            new_send:                       'Enviar resposta',
            proposal:                       'Proposta',
            proposal_close:                 'Encerrar proposta',
            proposal_close_confirm:         'Tem a certeza que quer encerrar esta proposta?',
            proposal_closed:                'Proposta encerrada',
            proposal_closed_email_sent:     'A sua proposta foi dada como resolvida.',
            proposal_error:                 'Erro no envio da proposta',
            proposal_new:                   'Nova proposta',
            proposal_response_email_sent:   'A sua proposta foi respondida.',
            proposal_success:               'Proposta enviada com sucesso',
            proposals:                      'Propostas',
            send:                           'Enviar',
            service:                        'Serviço / Produto',
            show_archive:                   'Mostrar arquivo',
            show_open:                      'Mostrar pendentes',
            subject_assistance_email:       'Assistência',
            subject_complaint_email:        'Reclamação',
            subject_proposal_email:         'Proposta',
            subject_suggestion_email:       'Sugestão',
            suggestion:                     'Sugestão',
            suggestion_close:               'Encerrar sugestão',
            suggestion_close_confirm:       'Tem a certeza que quer encerrar esta sugestão?',
            suggestion_closed:              'Sugestão encerrada',
            suggestion_closed_email_sent:   'A sua sugestão foi dada como resolvida.',
            suggestion_error:               'Erro no envio da sugestão',
            suggestion_new:                 'Nova sugestão',
            suggestion_response_email_sent: 'A sua sugestão foi respondida.',
            suggestion_success:             'Sugestão enviada com sucesso',
            suggestions:                    'Sugestões',
            table_empty:                    'Sem dados para mostrar',
            time_second:                    'segundo',
            time_seconds:                   'segundos',
            time_minute:                    'minuto',
            time_minutes:                   'minutos',
            time_hour:                      'hora',
            time_hours:                     'horas',
            time_day:                       'dia',
            time_days:                      'dias',
            time_week:                      'semana',
            time_weeks:                     'semanas',
            time_mount:                     'mês',
            time_mounts:                    'meses',
            time_year:                      'ano',
            time_years:                     'anos',
            unread:                         'por ler',
        },  
    'es':
        {
            assistance:                     'Assistência',
            assistance_close:               'Encerrar assistência',
            assistance_close_confirm:       'Tem a certeza que quer encerrar esta assistência?',
            assistance_closed:              'Pedido de assistência encerrado',
            assistance_closed_email_sent:   'O seu pedido de assistência foi dada como resolvida.',
            assistance_error:               'Erro no envio da assistência',
            assistance_new:                 'Nova assistência',
            assistance_response_email_sent: 'O seu pedido de assistência foi respondido.',
            assistance_success:             'Assistência enviada com sucesso',
            assistances:                    'Assistências',
            at:                             'às',
            back:                           'Voltar',
            cancel:                         'Cancelar',
            complaint:                      'Reclamacão',
            complaint_close:                'Encerrar reclamação',
            complaint_close_confirm:        'Tem a certeza que quer encerrar esta reclamação?',
            complaint_closed:               'Reclamação encerrada',
            complaint_closed_email_sent:    'A sua reclamação foi dada como resolvida.',
            complaint_error:                'Erro no envio da reclamação',
            complaint_new:                  'Nova reclamação',
            complaint_response_email_sent:  'A sua reclamação foi respondida.',
            complaint_success:              'Reclamacão enviada com sucesso',
            complaints:                     'Reclamações',
            confirm:                        'Confirmar',
            choose_client:                  'Escolher cliente',
            choose_service:                  'Escolher serviço/produto',
            label_info:                     'Iníciado',
            label_warning:                  'Em curso',
            label_success:                  'Finalizado',
            message:                        'Descrição',
            new_message:                    'Responder',
            new_send:                       'Enviar resposta',
            proposal:                       'Proposta',
            proposal_close:                 'Encerrar proposta',
            proposal_close_confirm:         'Tem a certeza que quer encerrar esta proposta?',
            proposal_closed:                'Proposta encerrada',
            proposal_closed_email_sent:     'A sua proposta foi dada como resolvida.',
            proposal_error:                 'Erro no envio da proposta',
            proposal_new:                   'Nova proposta',
            proposal_response_email_sent:   'A sua proposta foi respondida.',
            proposal_success:               'Proposta enviada com sucesso',
            proposals:                      'Propostas',
            send:                           'Enviar',
            service:                        'Serviço / Produto',
            show_archive:                   'Mostrar arquivo',
            show_open:                      'Mostrar pendentes',
            subject_assistance_email:       'Assistência',
            subject_complaint_email:        'Reclamação',
            subject_proposal_email:         'Proposta',
            subject_suggestion_email:       'Sugestão',
            suggestion:                     'Sugestão',
            suggestion_close:               'Encerrar sugestão',
            suggestion_close_confirm:       'Tem a certeza que quer encerrar esta sugestão?',
            suggestion_closed:              'Sugestão encerrada',
            suggestion_closed_email_sent:   'A sua sugestão foi dada como resolvida.',
            suggestion_error:               'Erro no envio da sugestão',
            suggestion_new:                 'Nova sugestão',
            suggestion_response_email_sent: 'A sua sugestão foi respondida.',
            suggestion_success:             'Sugestão enviada com sucesso',
            suggestions:                    'Sugestões',
            table_empty:                    'Sem dados para mostrar',
            time_second:                    'segundo',
            time_seconds:                   'segundos',
            time_minute:                    'minuto',
            time_minutes:                   'minutos',
            time_hour:                      'hora',
            time_hours:                     'horas',
            time_day:                       'dia',
            time_days:                      'dias',
            time_week:                      'semana',
            time_weeks:                     'semanas',
            time_mount:                     'mês',
            time_mounts:                    'meses',
            time_year:                      'ano',
            time_years:                     'anos',
            unread:                         'por ler',
        },
    'fr': 
        {
            assistance:                     'Assistência',
            assistance_close:               'Encerrar assistência',
            assistance_close_confirm:       'Tem a certeza que quer encerrar esta assistência?',
            assistance_closed:              'Pedido de assistência encerrado',
            assistance_closed_email_sent:   'O seu pedido de assistência foi dada como resolvida.',
            assistance_error:               'Erro no envio da assistência',
            assistance_new:                 'Nova assistência',
            assistance_response_email_sent: 'O seu pedido de assistência foi respondido.',
            assistance_success:             'Assistência enviada com sucesso',
            assistances:                    'Assistências',
            at:                             'às',
            back:                           'Voltar',
            cancel:                         'Cancelar',
            complaint:                      'Reclamacão',
            complaint_close:                'Encerrar reclamação',
            complaint_close_confirm:        'Tem a certeza que quer encerrar esta reclamação?',
            complaint_closed:               'Reclamação encerrada',
            complaint_closed_email_sent:    'A sua reclamação foi dada como resolvida.',
            complaint_error:                'Erro no envio da reclamação',
            complaint_new:                  'Nova reclamação',
            complaint_response_email_sent:  'A sua reclamação foi respondida.',
            complaint_success:              'Reclamacão enviada com sucesso',
            complaints:                     'Reclamações',
            confirm:                        'Confirmar',
            choose_client:                  'Escolher cliente',
            choose_service:                  'Escolher serviço/produto',
            label_info:                     'Iníciado',
            label_warning:                  'Em curso',
            label_success:                  'Finalizado',
            message:                        'Descrição',
            new_message:                    'Responder',
            new_send:                       'Enviar resposta',
            proposal:                       'Proposta',
            proposal_close:                 'Encerrar proposta',
            proposal_close_confirm:         'Tem a certeza que quer encerrar esta proposta?',
            proposal_closed:                'Proposta encerrada',
            proposal_closed_email_sent:     'A sua proposta foi dada como resolvida.',
            proposal_error:                 'Erro no envio da proposta',
            proposal_new:                   'Nova proposta',
            proposal_response_email_sent:   'A sua proposta foi respondida.',
            proposal_success:               'Proposta enviada com sucesso',
            proposals:                      'Propostas',
            send:                           'Enviar',
            service:                        'Serviço / Produto',
            show_archive:                   'Mostrar arquivo',
            show_open:                      'Mostrar pendentes',
            subject_assistance_email:       'Assistência',
            subject_complaint_email:        'Reclamação',
            subject_proposal_email:         'Proposta',
            subject_suggestion_email:       'Sugestão',
            suggestion:                     'Sugestão',
            suggestion_close:               'Encerrar sugestão',
            suggestion_close_confirm:       'Tem a certeza que quer encerrar esta sugestão?',
            suggestion_closed:              'Sugestão encerrada',
            suggestion_closed_email_sent:   'A sua sugestão foi dada como resolvida.',
            suggestion_error:               'Erro no envio da sugestão',
            suggestion_new:                 'Nova sugestão',
            suggestion_response_email_sent: 'A sua sugestão foi respondida.',
            suggestion_success:             'Sugestão enviada com sucesso',
            suggestions:                    'Sugestões',
            table_empty:                    'Sem dados para mostrar',
            time_second:                    'segundo',
            time_seconds:                   'segundos',
            time_minute:                    'minuto',
            time_minutes:                   'minutos',
            time_hour:                      'hora',
            time_hours:                     'horas',
            time_day:                       'dia',
            time_days:                      'dias',
            time_week:                      'semana',
            time_weeks:                     'semanas',
            time_mount:                     'mês',
            time_mounts:                    'meses',
            time_year:                      'ano',
            time_years:                     'anos',
            unread:                         'por ler',
        },

}

module.exports = {
    language
};